import { render, staticRenderFns } from "./StarQrisPayment.vue?vue&type=template&id=ae574d72&scoped=true&"
import script from "./StarQrisPayment.vue?vue&type=script&lang=js&"
export * from "./StarQrisPayment.vue?vue&type=script&lang=js&"
import style0 from "./StarQrisPayment.vue?vue&type=style&index=0&id=ae574d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae574d72",
  null
  
)

export default component.exports